import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useConfirmation } from "go-form/components/ModalConfirm";
import useDashboardContext from "../../services/hooks/useDashboardContext";
import { useDashboardSegment } from "../../services/hooks/useDashboardSegment";

export const EditModeTriggerButton = () => {
	const { isEditMode, setIsEditMode, setIsGridResettingMode } = useDashboardContext();
	const confirmation = useConfirmation();
	const { didDashboardSegmnetGridConfigChange } = useDashboardSegment();
	const { t } = useTranslation();

	const editDashboardButtonClickHandler = async () => {
		try {
			if (isEditMode && didDashboardSegmnetGridConfigChange()) {
				await confirmation({
					title: t("confirmation.message.cancel", { ns: "lib" }),
					message: t("modules.dashboard.field.unsaved_changes.title"),
				});
				setIsGridResettingMode(true);
			}
			setIsEditMode((prevEditMode: boolean) => !prevEditMode);
		} catch (err) {
			return null;
		}
	};

	const buttonText = isEditMode
		? t("modules.dashboard.action.cancel_edit.title")
		: t("modules.dashboard.action.edit_dashboard.title");

	return <Button onClick={editDashboardButtonClickHandler}>{buttonText}</Button>;
};
